import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Register";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe mis à jour");
      navigate("/connexion");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nouveau mot de passe" subtitle="Choisissez un mot de passe de 6 caractères minimum.">
      {!token ? (
        <p data-testid="reset-no-token" className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">
          Lien invalide.{" "}
          <Link to="/mot-de-passe-oublie" className="underline">
            Refaire une demande
          </Link>
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="reset-form">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.16em] text-[#5E5356]">Mot de passe</Label>
            <Input
              data-testid="reset-password-input"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 rounded-xl border-[#E8D7D0] focus-visible:ring-[#B76E79]"
            />
          </div>
          {error && (
            <p data-testid="reset-error" className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="reset-submit-btn"
            className="w-full h-12 rounded-full bg-[#B76E79] hover:bg-[#A25D67] text-white text-base"
          >
            {loading ? "Enregistrement…" : "Mettre à jour"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
